var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.WMenuItem,[_c(_setup.WLink,{staticClass:"item-link",attrs:{"selected":_vm.selected},on:{"click":function($event){return _setup.emit('click')}}},[_vm._t("default",function(){return [_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }